import { Trash2, Upload, Image as ImageIcon } from "lucide-react";

export default function LogoSection({ form, patch, uploading, onUploadLogo, fileInputRef }) {
  return (
    <div>
      <label className="label-luxe flex items-center gap-1.5">
        <ImageIcon size={11} /> Logo
      </label>
      <div className="grid grid-cols-2 gap-2">
        <button
          onClick={() => fileInputRef.current?.click()}
          className="btn-ghost !h-11 text-sm flex items-center justify-center gap-2"
          data-testid="branding-upload-logo-btn"
          disabled={uploading}
        >
          <Upload size={14} />
          {uploading ? "Uploading…" : form.logo_storage_path ? "Replace logo" : "Upload logo"}
        </button>
        <button
          onClick={() => patch("logo_storage_path", "")}
          className="btn-ghost !h-11 text-sm flex items-center justify-center gap-2"
          disabled={!form.logo_storage_path}
          data-testid="branding-remove-logo-btn"
        >
          <Trash2 size={14} /> Remove
        </button>
        <input
          type="file"
          ref={fileInputRef}
          accept="image/png,image/jpeg,image/webp"
          className="hidden"
          onChange={onUploadLogo}
        />
      </div>
      <p className="text-[11px] text-white/40 mt-1.5">
        Square PNG/JPG/WebP works best. Max 8MB. Leave empty to use the first letter of your firm name.
      </p>
    </div>
  );
}
